module.exports = __webpack_public_path__ + "static/media/BNB-USDT.93db5a31.png";